import { fromJS } from "immutable";

export default fromJS({
	email: "",
	password: "",
});
